/* Get proper JWT - also keep ColdFusion session alive, otherwise it times out after 30 mins */
function refresh () {
  const user = JSON.parse(window.localStorage.getItem('user'))
  if (user && user.token) {
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + user.token }
    }

    window.fetch(`${process.env.VUE_APP_CF_BASE}/newUserve.cfm`)

    return window.fetch(`${process.env.VUE_APP_API_URL}/refresh`, requestOptions)
      .then(handleResponse)
      .then(token => {
        return token
      })
  } else {
    return false
  }
}

/* For now, Login will be handled by ColdFusion via a set of redirects. */
function login (email, password) {
  /*const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password })
  }

  return window.fetch(`${process.env.VUE_APP_API_URL}/login`, requestOptions)
    .then(handleResponse)
    .then(user => {
      if (user.token && user.twofactor !== 1) {
        window.localStorage.setItem('user', JSON.stringify(user))
      }
      return user
    })*/
}

/* Currently still works mostly via ColdFusion app. Use a then() to redirect to /logout */
function logout () {
  localStorage.removeItem('user');
  /*return authHeader().then((token) => {
    const requestOptions = {
      method: 'GET',
      headers: token
    }
    return window.fetch(`${process.env.VUE_APP_API_URL}/jwt/logout/session`, requestOptions).then(function (response) {
      window.localStorage.removeItem('user')
    })
  })*/
}

function handleResponse (response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text)

    if (!response.ok) {
      if (response.status === 401) {
        window.localStorage.removeItem('user')
        window.location = '/login'
      }
      const error = (data && data.error) || response.statusText
      return Promise.reject(error)
    }

    return data
  })
}

export const authService = {
  login,
  logout,
  refresh
}
